import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-telegram',
  standalone: true,
  templateUrl: '../../assets/telegram.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamTelegramIcon {}
